export const PENDING = <div className="dot" id="yellow" />;
export const ACTIVE = <div className="dot" id="green" />;
export const PAST = <div className="dot" />;
export const DONE = <div className="dot" id="blue" />;
export const REJECTED = <div className="dot" id="red" />;
export const RESOLVED = <div className="dot" id="light_blue" />;
export const ACTIVE_SMALL = <div className="small_dot" id="green" />;
export const PENDING_SMALL = <div className="small_dot" id="yellow" />;
export const RESOLVED_SMALL = <div className="small_dot" id="light-blue" />;
export const DONE_SMALL = <div className="small_dot" id="blue" />;
export const REJECTED_SMALL = <div className="small_dot" id="red" />;
export const PAST_SMALL = <div className="small_dot" />;
